import React, { useEffect, useRef, useState } from 'react'
import { evidences } from '../app/Paths'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { FaRegFilePdf } from 'react-icons/fa'

export const ModalGallery = ({
  images = [],
  onClose,
  closeOnEscape = true,
  closeOnBackdrop = true
}) => {

  const [isVisible, setIsVisible] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const dialogRef = useRef(null)

  // Fade-in al montar
  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10)
  }, [])

  // Cerrar con Escape
  useEffect(() => {
    if (!closeOnEscape) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleClose()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [closeOnEscape])

  // Click fuera del modal
  const handleBackdropClick = (e) => {
    if (!closeOnBackdrop) return
    if (dialogRef.current && !dialogRef.current.contains(e.target)) {
      handleClose()
    }
  }

  // Animación de cierre
  const handleClose = () => {
    setIsVisible(false)
    setTimeout(onClose, 250)
  }

  // Navegación
  const handleSelect = (index) => setActiveIndex(index)

  const nextImage = () => {
    setActiveIndex((prev) => (prev + 1) % images.length)
  }

  const prevImage = () => {
    setActiveIndex((prev) => (prev - 1 + images.length) % images.length)
  }

  // Construir URL final
  const getImageSrc = (filePath) =>
    `${evidences.urlProd}${filePath}`

  // Protección por si aún no hay imágenes
  if (!images.length) return null

  const activeImage = images[activeIndex];

  const isImage = (mime) => mime?.startsWith('image/')
  const isPDF = (mime) => mime === 'application/pdf'

  return (
    <div className={`modal d-block custom-backdrop ${isVisible ? 'show' : ''}`} onClick={handleBackdropClick}    >
      <div ref={dialogRef} className={`modal-dialog modal-lg custom-modal-animate ${isVisible ? 'show' : ''}`}      >
        <div className="modal-content bg-white">
          {/* HEADER */}
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Evidencias</h5>
            <button className="btn-close" onClick={handleClose}></button>
          </div>

          {/* BODY */}
          <div className="modal-body">
            <div className="d-flex flex-column flex-md-row gap-3">

              {/* THUMBNAILS */}
              <div className="d-flex flex-md-column gap-2 overflow-auto" style={{ maxHeight: '500px' }}>
                {images.map((img, index) => (
                  <div key={index} className={`border rounded p-1 ${index === activeIndex ? 'bg-primary bg-opacity-25' : ''}`}
                    style={{ cursor: 'pointer', width: '100px' }} onClick={() => handleSelect(index)} >
                    {/* <img src={getImageSrc(img.FILEPATH)} alt={img.ORIGINALNAME} className="img-fluid rounded" /> */}
                    {isPDF(img.MIME_TYPE) ? (
                      <> <FaRegFilePdf size={40} className="text-danger" /> <span className='fw-bold text-danger'>PDF</span></>
                    ) : (
                      <img
                        src={getImageSrc(img.FILEPATH)}
                        alt={img.ORIGINALNAME}
                        className="img-fluid rounded"
                      />
                    )}
                  </div>
                ))}
              </div>

              {/* IMAGE VIEWER */}
              <div className="flex-fill position-relative border rounded d-flex align-items-center justify-content-center bg-light" style={{
                maxHeight: '500px', maxWidth: '100%', aspectRatio: '4 / 3', overflow: 'hidden'
              }}>
                <button className="btn btn-light position-absolute start-0 top-50 translate-middle-y" onClick={prevImage}>
                  <FiChevronLeft size={48} />
                </button>

                {/* <img src={getImageSrc(activeImage.FILEPATH)} alt={activeImage.ORIGINALNAME} className="img-fluid rounded"
                  style={{
                    maxHeight: '100%',
                    maxWidth: '100%',
                    objectFit: 'contain'
                  }}
                /> */}
                {isImage(activeImage.MIME_TYPE) && (
                  <img
                    src={getImageSrc(activeImage.FILEPATH)}
                    alt={activeImage.ORIGINALNAME}
                    className="img-fluid rounded"
                    style={{
                      maxHeight: '100%',
                      maxWidth: '100%',
                      objectFit: 'contain'
                    }}
                  />
                )}

                {isPDF(activeImage.MIME_TYPE) && (
                  <iframe
                    src={getImageSrc(activeImage.FILEPATH)}
                    title={activeImage.ORIGINALNAME}
                    style={{
                      width: '100%',
                      height: '100%',
                      border: 'none'
                    }}
                  />
                )}

                <button className="btn btn-light position-absolute end-0 top-50 translate-middle-y" onClick={nextImage}>
                  <FiChevronRight size={48} />
                </button>
              </div>
            </div>

            {/* ACTIONS */}
            <div className='text-end'>
              <small className="text-muted text-truncate d-block">
                {activeImage.ORIGINALNAME}
              </small>
            </div>
            <div className="mt-3 text-center">

              <a href={getImageSrc(activeImage.FILEPATH)} target="_blank" rel="noopener noreferrer" className="btn btn-outline-dark"              >
                Ver imagen en tamaño completo
              </a>
            </div>
          </div>

          {/* FOOTER */}
          <div className="modal-footer">
            <button className="btn btn-outline-dark" onClick={handleClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
